import Vue from 'vue';
import Router from 'vue-router';

import user from './user';
import meetingPlan from './meetingplan';
import messages from './messages';

const Login = resolve => require(['@/components/page/Login'], resolve);
const LoginSSO = resolve => require(['@/components/page/LoginSSO'], resolve);
const timeOutPage = resolve => require(['@/components/page/401'], resolve);
const NotFoundPage = resolve => require(['@/components/page/404'], resolve);
const ErrorPage = resolve => require(['@/components/page/500'], resolve);
const RulesErrorPage = resolve => require(['@/components/page/403'], resolve);

Vue.use(Router);

const whileList = ',login,login2,loginSSO,NotFoundPage,'

//获取原型对象上的push函数
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [{
    path: '/',
    redirect: '/login2'
  }, 
    meetingPlan,
    user,
    messages,
  {
    path: '/login',
    name: 'login',
    component: LoginSSO,
    label: '用户登录'
  }, {
    path: '/login2',
    name: 'login2',
    component: Login,
    label: '用户登录'
  }, {
    path: '/loginSSO',
    name: 'loginSSO',
    component: LoginSSO,
    label: '用户登录'
  }, {
    path: '/401',
    component: timeOutPage,
    label: '401'
  }, {
    path: '/404',
    component: NotFoundPage,
    label: '404'
  }, {
    path: '/500',
    component: ErrorPage,
    label: '500'
  }, {
    path: '/403',
    component: RulesErrorPage,
    label: '403'
  }, {
    path: '*',
    redirect: '/404'
  }],
  // mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

router.beforeEach((to, from, next) => {  
  if(whileList.indexOf(to.name) < 0 && to.name) {
    if(!Vue.prototype.$hasPermissionByRouteName(to.name) //没有权限) 
    ){
      next({ name: 'login2' });
      return;
    }
  }

  if(to.meta.pagetitle) {   //路由发生变化时候修改页面中的title
    document.title = to.meta.pagetitle
  }
  else {
    document.title = 'Roche Event Planning Plarform'
  }
  
  next();
});

router.afterEach((to) => {

});

router.onError((error) => {
  console.log(error);
  //   const pattern = /Loading chunk/g;
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);

  const targetPath = router.history.pending.fullPath;
  console.log('targetPath', targetPath);
  if (isChunkLoadFailed && targetPath) {
    console.log('chunkfailed catched');
    router.push(targetPath);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js